import {
    defineStore
} from 'pinia';

import dogBreeds from "../data/dogBreeds";
import catBreeds from "../data/catBreeds";
import species from "../data/species";

export const usePetStore = defineStore('petStore', {
    state: () => ({
        apiKey: '8jw5smPC',
        apiUrl: 'https://api.rescuegroups.org/v5/public/animals/search/available/haspic?fields[animals]=distance,name,descriptionText,ageGroup,sizeGroup,breedString,breedPrimary,sex,isCurrentVaccinations,coatLength,isDogsOk,isKidsOk,priority,pictureThumbnailUrl&include=colors,orgs,pictures&limit=12',
        wpdata: window.wpdata ? window.wpdata : null,
        ajaxUrl: window.wpdata && window.wpdata.ajax_url ? window.wpdata.ajax_url : null,
        isLoading: false,
        sideNavOpen: false,
        petDetailsModalOpen: false,
        favoritesModalOpen: false,
        loginPromptOpen: false,
        lastPageLoaded: 0,
        maxPages: null,
        resultCount: null,
        petFilters: [{
                "fieldName": "species.plural",
                "operation": "equals",
                "criteria": "dogs" // see species filter txt
            }
        ],
        dogBreeds: dogBreeds,
        catBreeds: catBreeds,
        species: species,
        distanceFilters: null,
        pets: [],
        selectedPetId: null,
        loggedOutFavoriteId: null,
        petMetaData: [],
        favorites: [],
        favoritePetsMetaData: [],
        favoritePetIds: [],
        name: 'PETS'
    }),
    getters: {
        favoritePets() {
            return this.favorites;
        },
        isFav: (state) => {
            return (petId) => state.favoritePetIds.indexOf(petId) > -1

        },
        getLoggedOutFavoriteId() {
            return this.loggedOutFavoriteId;
        },
        isUserLoggedIn() {
            return this.wpdata ? this.wpdata.is_user_logged_in == 1 : false;
        },
        getSelectedPetData() {
            const petId =  this.selectedPetId;
            const petDetails = this.petById(petId);
            const petOrgData = this.petOrgById(petId);
            const petThumb = this.petThumbById(petId);
            return {
                petId : petId,
                details : petDetails,
                petOrgData : petOrgData,
                petThumb : petThumb
            }
        },
        getBreedOptions() {
            return this.breedOptions;
        },
        getBreedByName: (state) => {
            return (speciesCategory, breedName) => {
              if (speciesCategory === "dogs") {
                return state.dogBreeds.find(breed => breedName === breed.title) || null;
              } else if (speciesCategory === "cats") {
                return state.catBreeds.find(breed => breedName === breed.title) || null;
              } else {
                return null;
              }
            };
          },
        
        totalCount: (state) => {
            //NOTE: Since you are using an arrow function here(optional format) 
            //the this keyword doesn't refer to the state anymore so you need to pass it in
            return state.pets.length;
        },
        petById: (state) => {
            return (petId) => state.isFav(petId) && !state.pets.find(pet => petId == pet.id) ? state.favorites.find(pet => petId == pet.id) : state.pets.find(pet => petId == pet.id)
        },
        petMetaById: (state) => {
            return (petId) => state.isFav(petId) && !state.pets.find(pet => petId == pet.id) ? state.favoritePetsMetaData : state.petMetaData;
        },
        petOrgById: (state) => {
            return (petId) => {
                const pet = state.petById(petId);
                const petMeta = state.petMetaById(petId);
                if (!pet || !petMeta) {
                    return false;
                }
                const petOrgId = pet.relationships.orgs.data[0].id;
                const orgmeta = petMeta.find(meta => petOrgId == meta.id && 'orgs' == meta.type);
                return orgmeta ? orgmeta.attributes : null;
            }
        },
        petThumbById: (state) => {
            return (petId) => {
                const pet = state.petById(petId);
                const petMeta = state.petMetaById(petId);
                if (!pet || !petMeta) {
                    return false;
                }
                const petThumbId = pet.relationships.pictures ? pet.relationships.pictures.data[0].id : null;
                if (!petThumbId) {
                    return false;
                }
                const imagemeta = petMeta.find(meta => petThumbId == meta.id && 'pictures' == meta.type);
                return imagemeta && imagemeta.attributes.large ? imagemeta.attributes.large.url : null;


            }
        },
        petHasGallery: (state) => {
            return (petId) => {
                const pet = state.petById(petId);
  
                if (!pet) {
                    return false;
                }          
                return pet.relationships.pictures ? pet.relationships.pictures.data.length > 1 : false;
                
            }
        },
        petGalleryById: (state) => {
            return (petId) => {
                const pet = state.petById(petId);
                const petMeta = state.petMetaById(petId);
                const petHasGallery = state.petHasGallery(petId);
                if (!pet || !petMeta || !petHasGallery) {
                    return false;
                }
                const petImageData = pet.relationships.pictures.data;
                const petImageIds = [];
                const petImageUrls = [];

                for (let i = 0; i < petImageData.length; i++) {
                    const imageDataObj = petImageData[i];
                    petImageIds.push(imageDataObj.id)                    
                }

                for (let i = 0; i < petImageIds.length; i++) {
                    const imageId = petImageIds[i];
                    const imagemeta = petMeta.find(meta => imageId == meta.id && 'pictures' == meta.type);  
                    if(imagemeta && imagemeta.attributes.large) {
                        petImageUrls.push(imagemeta.attributes.large.url)       
                    }                 
                }

                return petImageUrls.length > 0 ? petImageUrls : false;

            }
        },
        petColorById: (state) => {
            return (petId) => {
                const pet = state.petById(petId);
                const petColorId = pet.relationships.colors ? pet.relationships.colors.data[0].id : null;
                if (!petColorId) {
                    return false;
                }
                const colormeta = state.petMetaData.find(meta => petColorId == meta.id && 'colors' == meta.type);
                return colormeta ? colormeta.attributes.name : null;
            }
        },
        isSideNavOpen() {
            return this.sideNavOpen
        },
        isFavoritesModalOpen() {
            return this.favoritesModalOpen
        },
        isPetDetailsModalOpen() {
            return this.petDetailsModalOpen
        }
    },
    actions: {
        init() {
           this.setInitialFavorites();
           this.setInitialFilters();
           this.fetchPets();
        //    console.log('wpdata:' , this.wpdata)
        //    console.log(this.isUserLoggedIn)
         
        },
        async setInitialFilters() {
            // set filters pulled from shortcodes
            if(!window.initialFilters) {
                this.initialFilters = null;
                return false;
            }  

            let shortcodeFilters = window.initialFilters;
            let speciesCategory = shortcodeFilters.species == "dogs" ||  shortcodeFilters.species == "cats" ?   shortcodeFilters.species : "others";

            let filterData = {

                "speciesCategory" : speciesCategory,
                "species" : [shortcodeFilters.species] || null,
                "sex" : shortcodeFilters.sex || null,
                "ageGroup" : shortcodeFilters.age ?   {"label": shortcodeFilters.age, "value": shortcodeFilters.age} : null,
                "breeds" : shortcodeFilters.breedname && this.getBreedByName(speciesCategory, shortcodeFilters.breedname) ? [this.getBreedByName(speciesCategory, shortcodeFilters.breedname)] : null
            };
            console.log(filterData)

            this.initialFilters = filterData; // needed for sidenav 
            const filters = this.generateFilterData(filterData);
            this.petFilters = filters;

            if (shortcodeFilters.postalcode || shortcodeFilters.miles) {
                this.distanceFilters = {
                    "postalcode" : shortcodeFilters.postalcode,
                    "miles" : shortcodeFilters.miles
                };
            }

        },
        async setInitialFavorites() {
            if(!window.favoritePetIds && !this.getUrlParameter('favoritedid')) {
                return false;
            }

            if(window.favoritePetIds) {
                this.favoritePetIds = window.favoritePetIds;
            }       

            if(this.getUrlParameter('favoritedid')) {
                // if there's a favorited id param in the url 
                const favoritedBeforeSignin = this.getUrlParameter('favoritedid');
                // this.favoritePetIds.push(favoritedBeforeSignin);
                // await this.fetchFavorites();
                await this.addFavorite(favoritedBeforeSignin);
                if(this.petById(favoritedBeforeSignin)) {
                 
                    this.openPetDetailsModal(favoritedBeforeSignin);
                }
                
            }

        },
        // Filtering
        updateDistanceFilters(data) {
            this.resetPagination();
            if (!data.postalcode || !data.miles) {
                this.distanceFilters = null;
                this.fetchPets();
                return false;
            }
            this.distanceFilters = data;
            this.fetchPets();
            this.closeSideNav();
        },
        updatePetFilters(data) {
            console.log('updatepetfilters triggered')
            const filters = this.generateFilterData(data);

            this.petFilters = filters;
            this.resetPagination();
            this.fetchPets();
            this.closeSideNav();

        },
        generateFilterData(data) {
            //  console.log(data)
             let filters = [];
            // console.log('filterdata:')
            // console.log(data)

            if (data.species) {
                const speciesNames = [];
                for (let i = 0; i < data.species.length; i++) {
                    const speciesName = data.species[i];
                    speciesNames.push(speciesName);
                }
                const speciesFilter = {
                    "fieldName": "species.plural",
                    "operation": "equals",
                    "criteria": speciesNames
                }
                filters.push(speciesFilter);

            }
            if (data.breeds && data.breeds.length > 0) {
                const breedPrimaryIds = [];
                for (let i = 0; i < data.breeds.length; i++) {
                    const breedPrimaryId = data.breeds[i].value;
                    breedPrimaryIds.push(breedPrimaryId);
                }
                const breedFilter = {
                    "fieldName": "animals.breedPrimaryId",
                    "operation": "equals",
                    "criteria": breedPrimaryIds
                }
                filters.push(breedFilter);

            }
            if (data.sex) {
                const sexFilter = {
                    fieldName: "animals.sex",
                    operation: "equals",
                    criteria: data.sex
                }
                filters.push(sexFilter);
            }
            if (data.ageGroup != null) {
                // console.log(data.ageGroup.value)
                const ageFilter = {
                    fieldName: "animals.ageGroup",
                    operation: "equals",
                    criteria: data.ageGroup.value
                }
                filters.push(ageFilter);
            }
            console.log(filters)
            return filters;
        },
        resetPagination() {
            this.lastPageLoaded = 0;
            this.maxPages = null;
            this.resultCount = null;
        },
        async fetchFavorites() {

            if (this.favoritePetIds.length == 0) {
                this.favorites = [];
                this.favoritePetsMetaData = [];
                return false;
            }
            let filters = [];

            const favoritesFilter = {
                "fieldName": "animals.id",
                "operation": "equals",
                "criteria": this.favoritePetIds
            }
            filters.push(favoritesFilter);
            const apiURL = this.apiUrl;
            const response = await fetch(apiURL, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': this.apiKey,
                },
                body: JSON.stringify({
                    data: {
                        filters: filters
                    }
                })
            });

            const responseData = await response.json();

            if (responseData && responseData.errors) {
                console.log(responseData.errors);
                // this.isLoading = false;           
                return false;
            }

            this.favorites = responseData.data;
            this.favoritePetsMetaData = responseData.included;

        },
        async fetchPets() {
            console.log('fetchpets triggered')
            if (this.maxPages === this.lastPageLoaded) {
                return false;
            }
            const pageToLoad = this.lastPageLoaded + 1;

            const filters = this.petFilters;
            console.log(filters)
            const filterRadius = this.distanceFilters;
            console.log('distancefilters:')
            console.log(this.distanceFilters)
            this.isLoading = true;

            // Note: if there are no fields, all the default fields in attributes are pulled - see defaultpetattributes.json
            const pageUrlParam = pageToLoad ? '&page=' + pageToLoad : '';
            const apiURL = this.apiUrl + pageUrlParam;
            const response = await fetch(apiURL, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': this.apiKey,
                },
                body: JSON.stringify({
                    data: {
                        filters: filters,
                        filterRadius: filterRadius
                    }
                })
            });

            const responseData = await response.json();
            //  console.log(responseData)
            if (responseData && responseData.errors) {
               
                console.log(responseData.errors);
                this.pets = [];
                this.resetPagination();
                this.isLoading = false;
                return false;
                // TODO - HANDLE INVALID POSTAL CODES
            }

            if (responseData.meta.count == 0 ) {
               
                this.pets = [];
                this.resetPagination();
                this.isLoading = false;
                return false;
            }

            if (responseData.meta.pageReturned == 1) {
                
                // initial load or new filter
                // console.log(responseData)
                this.pets = responseData.data;
                this.petMetaData = responseData.included;
            } else {
               
                // load more on scroll
                this.pets = this.pets.concat(responseData.data)
                this.petMetaData = this.petMetaData.concat(responseData.included)
            }
           
            this.lastPageLoaded = responseData.meta.pageReturned;
            this.maxPages = responseData.meta.pages;
            this.resultCount = responseData.meta.count;
            this.isLoading = false;

        },

        selectPet(petId) {
            this.selectedPetId = petId;
        },
        setLoggedOutFavorite(petId) {
            console.log(petId)
            this.loggedOutFavoriteId = petId;
        },

        // Favorites
        handleFavoriteClick(petId) {
            if(!this.isUserLoggedIn) {
                this.setLoggedOutFavorite(petId);
                 this.openLoginPrompt();
                return false;
            }

            this.isFav(petId) ? this.removeFavorite(petId) : this.addFavorite(petId);
        },
        async addFavorite(petId) {
            this.favoritePetIds.push(petId);
            await this.fetchFavorites();
            this.saveFavorites();
        },
        removeFavorite(petId) {

            this.favoritePetIds = this.favoritePetIds.filter(favoriteId => favoriteId !== petId);
            this.fetchFavorites();
            this.saveFavorites();
        },
        async saveFavorites() {
            const apiURL = this.wpdata.ajax_url;
            const nonce = this.wpdata.save_favorites_nonce;

            let params = new URLSearchParams({
                action: 'save_favorites',
                security: nonce,
                favorites: this.favoritePetIds,
            });

            let body = params.toString();
            const response = await fetch(apiURL, {
                method: 'POST',
                headers: { 'Content-type': 'application/x-www-form-urlencoded' },
                body: body
            });
            const responseData = await response.json();
            console.log(responseData);
            if (responseData && responseData.errors) {
                console.log(responseData.errors);
                // this.isLoading = false;           
                return false;

            }
        },
        getUrlParameter(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },
        // UI
        openSideNav() {
            this.sideNavOpen = true;

        },
        closeSideNav() {
            this.sideNavOpen = false;
        },
        openPetDetailsModal(petId) {
            this.selectPet(petId)
            document.documentElement.classList.add('is-overlay-open')
            document.body.classList.add('is-overlay-open')
            this.petDetailsModalOpen = true;

        },
        closePetDetailsModal() {
            this.petDetailsModalOpen = false;
            document.documentElement.classList.remove('is-overlay-open')
            document.body.classList.remove('is-overlay-open')
        },
        openFavoritesModal() {

            this.fetchFavorites();
            document.documentElement.classList.add('is-overlay-open')
            document.body.classList.add('is-overlay-open')
            this.favoritesModalOpen = true;

        },
        closeFavoritesModal() {
            this.favoritesModalOpen = false;
            document.documentElement.classList.remove('is-overlay-open')
            document.body.classList.remove('is-overlay-open')
        },
        openLoginPrompt() {
            this.loginPromptOpen = true;
        },
        closeLoginPrompt() {
            this.loginPromptOpen = false;
        }
    }
})